module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_vm._l((_vm.people), function(person, index) {
    return _c('div', [_c('div', {
      staticClass: "blue-bar"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(person.name) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "package"
    }, [(person.type === 'package') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ", paket")]) : _vm._e(), _vm._v(" "), (person.type === 'single') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ":")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.ages[person.age]) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "level"
    }, [(person.searchPackage === 'beginner') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Nybörjare")]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'intermediate') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Medelgod")]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'advanced') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Avancerad")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "date right"
    }, [_c('span', [_c('b', [_vm._v("Datum:")]), _vm._v(" " + _vm._s(_vm.dateRange(person)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "inner-width"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Längd (cm)")]), _vm._v("\n          " + _vm._s(person.lengthCm) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Vikt (kg)")]), _vm._v("\n          " + _vm._s(person.weight) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Skostorlek")]), _vm._v("\n          " + _vm._s(person.shoeSize) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, _vm._l((person.wishes), function(wish, key) {
      return (wish) ? _c('div', [_vm._v(_vm._s(_vm.wishesLabels[key]))]) : _vm._e()
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "addon--inner-width"
    }, [_c('div', {
      staticClass: "addons inner-width"
    }, [_c('div', {
      staticClass: "products"
    }, [_c('table', [_vm._l((person.products), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product && product.price) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _vm._l((person.addons), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product && product.price) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _c('tr', {
      staticClass: "total"
    }, [_c('td', [_vm._v("\n                Pris åkare " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((
      person.products.reduce(function(a, product) {
        return a + product.price
      }, 0) +
      person.addons.reduce(function(a, product) {
        return a + product.price
      }, 0)
    ))))])])])], 2)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "sum-bar"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n      Totalt:\n      "), _c('b', [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.sum)) + "\n      ")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0774b522"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiRental/SkiRentalConfirm.vue
// module id = 904
// module chunks = 0